import React, { useState, useEffect } from "react";
import Layout from "Component/Layouts/layout";

const steps = [
  "Step 1: Click the button below to visit the SFL Sangram portal",
  "Step 2: Enter your login details",
  "Step 3: Navigate to assigned courses.",
  "Step 4: Complete the courses.",
];

function ExternalLinks() {
  const [visibleStep, setVisibleStep] = useState(0);

  useEffect(() => {
    if (visibleStep < steps.length) {
      const timer = setTimeout(() => {
        setVisibleStep(visibleStep + 1);
      }, 700); // Delay before showing next step
      return () => clearTimeout(timer);
    }
  }, [visibleStep]);

  // Inline styles
  const containerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    textAlign: "center",
    fontFamily: "Roboto, sans-serif", // Using a clean, modern font
    backgroundColor: "#f8f9fa", // Light background color for a professional look
    padding: "20px", // Add some padding for spacing
  };

  const stepsContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row", // Horizontal layout
    gap: "30px", // Space between steps horizontally
  };

  const stepContainerStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const stepDotStyle = {
    width: "40px", // Adjusted dot size for a cleaner look
    height: "20px",
    borderRadius: "50%",
    backgroundColor: "#007bff",
    marginRight: "10px",
    opacity: 0,
    transition: "opacity 0.5s ease",
  };

  const stepLineStyle = {
    height: "2px",
    width: "50px", // Longer line to connect steps
    backgroundColor: "#007bff",
    opacity: 0,
    transition: "opacity 0.5s ease",
  };

  const stepArrowStyle = {
    fontSize: "24px",
    marginLeft: "10px",
    opacity: 0,
    transition: "opacity 0.5s ease",
  };

  const stepStyle = {
    fontSize: "18px",
    color: "#333", // Dark text color for readability
    opacity: 0,
    transition: "opacity 0.5s ease",
    fontWeight: "500", // Slightly bold for better emphasis
  };

  const stepShowStyle = {
    opacity: 1,
  };

  const linkStyle = {
    display: "inline-block",
    marginTop: "30px",
    fontSize: "16px",
    color: "#007bff",
    textDecoration: "none",
    fontWeight: "500",
    padding: "10px 20px",
    backgroundColor: "#e7f3ff",
    borderRadius: "5px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    transition: "background-color 0.3s ease",
  };

  const linkHoverStyle = {
    backgroundColor: "#cce5ff",
    textDecoration: "underline",
  };

  return (
    <Layout>
      <div style={containerStyle}>
        <div>
          <h1
            style={{
              fontSize: "28px",
              fontWeight: "600",
              color: "#333",
              marginBottom: "40px",
              marginTop: "-20px", // Move the title up
            }}
          >
            Follow the Steps to access SFL Sangram
          </h1>
          <div style={stepsContainerStyle}>
            {steps.map((step, index) => (
              <div key={index} style={stepContainerStyle}>
                {/* Dot */}
                <div
                  style={{
                    ...stepDotStyle,
                    ...(visibleStep >= index ? stepShowStyle : {}),
                  }}
                />
                {/* Step text */}
                <div
                  style={{
                    ...stepStyle,
                    ...(visibleStep >= index ? stepShowStyle : {}),
                  }}
                >
                  {step}
                </div>
                {/* Line connecting the steps */}
                {index < steps.length - 1 && (
                  <div
                    style={{
                      ...stepLineStyle,
                      ...(visibleStep > index ? stepShowStyle : {}),
                    }}
                  />
                )}
              </div>
            ))}
          </div>

          {visibleStep === steps.length && (
            <a
              href="https://sflsangram.wgab.world/onboard"
              target="_blank" // Opens the link in a new tab
              rel="noopener noreferrer"
              style={linkStyle}
              onMouseEnter={(e) =>
                (e.target.style.backgroundColor =
                  linkHoverStyle.backgroundColor)
              }
              onMouseLeave={(e) => (e.target.style.backgroundColor = "#e7f3ff")}
            >
              Click here To Login
            </a>
          )}
        </div>
      </div>
    </Layout>
  );
}

export default ExternalLinks;
